const getSearchResults = state => state.searchResults

export const getProducts = state => getSearchResults(state).productViewDetails?.catalogEntryView
export const getProductCount = state => getSearchResults(state).productViewDetails?.recordSetTotal
export const getFacets = state => getSearchResults(state).productViewDetails?.facetView
  ?.filter(facet => facet.value === 'parentCatgroup_id_search' || facet?.extendedData?.ffield3?.includes('C'))
export const getCategoryName = state => getSearchResults(state).category?.catalogGroupView?.[0]?.name